import * as Sentry from '@sentry/browser';
import type { AxiosError } from 'axios';
import type { ApiError } from '../models/error';

// 第三引数のhandleErrorは既存の実装をケアするために設定している。
// 今後廃止予定なので新規の実装で使ってはいけない。
export function handleAxiosError(
  error: AxiosError<ApiError>,
  notify?: (message: string, type: string) => void,
): void {
  if (Object.prototype.hasOwnProperty.call(error.response, 'data')) {
    const data = error.response?.data;
    if (data?.errorClassName === 'ActionController::InvalidAuthenticityToken') {
      // invalidAuthenticityTokenのエラーの場合にページを再読み込みし、
      // ログインセッションが切れている場合にログイン画面への遷移を促す
      window.location.reload();
      return;
    }
  }

  if (notify != null) {
    notify(buildErrorMessage(error), 'alert');
  }

  Sentry.captureException(error);
}

export function buildErrorMessage(error: AxiosError<ApiError>): string {
  let message =
    '問題が発生しました。時間を空けて再度お試しください。それでも改善しない場合は、画面右下のアイコンからお問合せください。';
  if (error.response?.status === 408) {
    // Request Timeout（ALBやNginxのタイムアウト）
    message =
      'タイムアウトしました。通信環境をご確認の上、時間を空けて再度お試しください。';
  } else {
    if (Object.prototype.hasOwnProperty.call(error.response, 'data')) {
      const data = error.response?.data;
      if (data != null) {
        if (
          data.errorClassName === 'ActionController::InvalidAuthenticityToken'
        ) {
          message =
            'ログインセッションが切れました。再度ログインしてください。';
        }

        if (Object.prototype.hasOwnProperty.call(data, 'message')) {
          message = data.message;
        }
      }
    }
  }

  return message;
}
